<template>
	<div class="editor">
		<iframe ref="iframe" class="iframe" :src="'http://ceditor.kjt61.com' + '?t=' + (new Date()).getTime()"></iframe>
	</div>
</template>

<script>
	export default {
		name: "editor",
		components: {},
		data() {
			return {
				title: "C++编辑器"
			}
		},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
	.editor {
		height: 100%;
		width: 100% !important;
		padding: 0 !important;
		overflow: hidden;
		background-color: black;
		.iframe{
			height: 100%;
			width: 100%;
			border: none;
		}
	}
</style>
